module.exports = __webpack_public_path__ + "img/aliapyTips1.2c8d7dfb.png";